import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import EmitenteForm from '../components/EmitenteForm';
import { maskCPF, maskCNPJ } from '../utils/Masker';
import moment from "moment-timezone"; // VALIDAR DATAS
import { getUsuario } from "../utils/LoginManager";
import { resolveImageUrl } from '../utils/Storage';
import { getTemPermissao } from "../utils/LoginManager";

const { Column } = Table;
const { Search } = Input;
const ButtonGroup = Button.Group;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    buscaOrdem: { campo: 'pes_nome', ordem: 'ASC' },
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/emitenteNF', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          buscaDescricao: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({ salvando: true })

    let request;
    if (registro.enf_idf) {
      request = axios.put(`/emitenteNF/update/${registro.enf_idf}`, registro);
    } else {
      request = axios.post(`/emitenteNF/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Empresa gravada com sucesso.');
      })
      .catch(error => {
        console.log(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
      })
  }


  onEditarClick = (registro, visualizar) => {
    this.setState({ carregando: true });
    axios.get(`/emitenteNF/show/${registro.enf_idf}`)
      .then(response => {
        const { data } = response;

        // console.log('onEditarClick', data)

        data.enf_cnpj = data.enf_cnpj.length === 11 ? maskCPF(data.enf_cnpj) : maskCNPJ(data.enf_cnpj);

        data.enf_municipio = {
          key: String(data.enf_municipio),
          label: data.cmun_descricao,
          cmun_uf: String(data.cmun_uf),
          cuf_sigla: data.cuf_sigla,
        }

        data.enf_crt = {
          key: data.enf_crt ? String(data.enf_crt) : '0',
          label: '',
        }

        data.enf_ambiente = {
          key: String(data.enf_ambiente),
        }

        data.enf_senha_certificado = '';
        data.enf_certificado = '';
        data.enf_certificado_nome = '';
        data.enf_data_certificado = data.enf_data_certificado
          ? moment(data.enf_data_certificado, 'YYYY-MM-DD').format('DD/MM/YYYY')
          : '';

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          visualizar,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      registroSelecionado: {
        enf_idf: 0,
        enf_cnpj: '',
        enf_razao_social: '',
        enf_ambiente: { key: '1' },

        enf_flag_nfe: 0,
        enf_nfe_numero: 0,
        enf_nfe_serie: 0,

        enf_flag_nfce: 0,
        enf_nfce_numero: 0,
        enf_nfce_serie: 0,
        enf_csc: '',
        enf_idcsc: '',

        enf_flag_nfse: 0,
        enf_nfse_numero: 0,
        enf_nfse_serie: 0,
        enf_login_prefeitura: '',
        enf_senha_prefeitura: '',

        enf_data_certificado: '',
        enf_cnae: '',
        enf_crt: '',
        enf_ie: '',
        enf_im: '',

        enf_email: '',
        enf_telefone: '',
        enf_cep: 0,
        enf_endereco: '',
        enf_num_ender: '',
        enf_compl_ender: '',
        enf_bairro: '',
        enf_municipio: {
          key: String(this.state.usuario.emp_municipio),
          label: this.state.usuario.cmun_descricao,
          cmun_uf: String(this.state.usuario.cmun_uf),
          cuf_sigla: this.state.usuario.cuf_sigla,
        },

        enf_token_homolog: '',
        enf_token_producao: '',
        enf_webhook: '',
        enf_senha_certificado: '',
        enf_certificado: '',
        enf_certificado_nome: '',
        certificado_local: false,
      }
    })
  };

  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/emitenteNF/delete/${registro.enf_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.enf_idf === registro.enf_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };


  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }

  renderAtiva = (enf_status, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={enf_status ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
      />
    );
  };

  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/emitenteNF/ativa/${registro.enf_idf}/1`)
    } else {
      request = axios.put(`/emitenteNF/ativa/${registro.enf_idf}/0`)
    }

    request.then(response => {
      registro.enf_status = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };


  renderPadrao = (enf_status, registro) => {
    return (
      <Switch
        checkedChildren="Principal"
        unCheckedChildren="Secundário"
        checked={enf_status ? true : false}
        onChange={ativar => this.onPadraoChange(registro, ativar)}
      />
    );
  };

  onPadraoChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/emitenteNF/emissorPadrao/${registro.enf_idf}/1`)
    } else {
      request = axios.put(`/emitenteNF/emissorPadrao/${registro.enf_idf}/0`)
    }

    request.then(response => {
      registro.enf_emissao_padrao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };



  renderPFJ = (enf_cpf_cnpj) => {
    if ((String(enf_cpf_cnpj).length) === 11) {
      return (
        <span>
          {maskCPF(enf_cpf_cnpj)}
        </span>
      );
    } else {
      return (
        <span>
          {maskCNPJ(enf_cpf_cnpj)}
        </span>
      );
    }
  };



  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        {getTemPermissao('EmitentesPage', 'editar') ? (
          <Tooltip title="Editar">
            <Button type="primary" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
          </Tooltip>
        ) : (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarClick(registro, true)} icon="eye" />
          </Tooltip>
        )}
        {getTemPermissao('EmitentesPage', 'excluir') ? (
          <Tooltip title="Excluir">
            <Button type="danger" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
          </Tooltip>
        ) : null}
      </ButtonGroup>
    );
  };


  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Emitentes de NFe</span>
        <div className="divider-page1" />

        <div className="pageFiltro">
          <Button
            type="primary"
            onClick={this.onAdicionarClick}
            className="botao-primary"
          >
            Adicionar
          </Button>

          <Search
            placeholder="Buscar por Nome"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <EmitenteForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          rowKey={(registro => registro.enf_idf)}
        >
          <Column
            key="enf_cnpj"
            dataIndex="enf_cnpj"
            title={this.renderTitulo("CNPJ")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderPFJ}
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="enf_razao_social"
            dataIndex="enf_razao_social"
            title={this.renderTitulo("Razão Social")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={420}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="enf_emissao_padrao"
            dataIndex="enf_emissao_padrao"
            title={this.renderTitulo("Ordem")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderPadrao}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="enf_status"
            dataIndex="enf_status"
            title={this.renderTitulo("Situação")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderAtiva}
            width={60}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
            render={this.renderAcoes}
            width={70}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EmitentesPage.js